import React from 'react';

import LoadingGif from "../../assets/gif/gif-logo.gif";

function Loading() {
    return (
        <div
            className="w-[100vw] h-[100vh] fixed top-0 left-0 flex items-center justify-center"
            style={{
                zIndex: 1000,
                background: "rgba(0, 0, 0, 0.5)"
            }}
        >
            <img src={LoadingGif} alt="DODEAL" className="w-[350px] h-[350px] rounded-full" />
        </div>
    );
}

export default Loading;
